import methods from '../methods'

const API_URL = '/api'

const getCategories = (query?: string) => methods.GET_API(`${API_URL}/categories?${query}`)

export default {
  getCategories
}
